import { getBoard, postBoardOps } from '../chatv1/transport'
import { MAIN_BOARD } from './boardNav'
import { inverseOps, type El, type Props } from './model'
import { useLiveRows, type LiveWire } from './useLiveRows'

export { activityOf, type Activity } from './useLiveRows'

/**
 * THE ROOM'S WHITEBOARD, LIVE — its elements as rows the room writes together (useLiveRows: read on open and on every
 * reconnect, `board` frames, one request at a time, a drag sent as it moves and undone as one step).
 *
 * One board of the room at a time (owner, 2026-10-30: 新增不同的 board). Picking another — or closing the board — a
 * moment after a change still delivers that change.
 */

/** What a refusal means to the person, in words. */
export function refusalText(code: string): string {
  switch (code) {
    case 'locked':
      return 'This board is locked: only the people its owner chose can change it.'
    case 'not_a_member':
      return 'You are no longer in this project, so the board cannot be changed.'
    case 'deleted':
      return 'Someone deleted that a moment ago.'
    case 'no_such_element':
      return 'That is no longer on the board.'
    case 'too_many_elements':
      return 'The board is full — delete something first.'
    case 'no_board':
      return 'This conversation has no whiteboard.'
    case 'no_such_board':
      return 'That board is not in this project.'
    default:
      return 'Some of that could not be saved.'
  }
}

const BOARD_WIRE: LiveWire<El, Props> = {
  read: async (conv, board) => {
    const r = await getBoard(conv, board)
    return { rev: r.rev, rows: r.elements }
  },
  post: async (conv, board, ops, client) => {
    const r = await postBoardOps(conv, board, ops, client)
    return { rev: r.rev, rows: r.elements, ...(r.refused ? { refused: r.refused } : {}) }
  },
  frame: (f, conv, board) =>
    f.type === 'board' && f.conv_id === conv && (f.board ?? MAIN_BOARD) === board
      ? {
          by: f.by,
          ...(f.via ? { via: f.via } : {}),
          ...(f.client ? { client: f.client } : {}),
          rev: f.rev,
          ...(f.elements ? { rows: f.elements } : {}),
          ...(f.reload ? { reload: true } : {}),
        }
      : null,
  missing: 'no_such_board',
  refusal: refusalText,
  inverse: inverseOps,
}

export function useBoard(convId: string | null, boardId: string) {
  return useLiveRows(BOARD_WIRE, convId, boardId)
}

export type BoardApi = ReturnType<typeof useBoard>
